{
  "iframeWaitingMessage": "感谢您的耐心等待。即将处理完毕...",
  "solutionIframe": "主要内容"
}
